const SECRET_KEY = "yQ51bngWcX2QZxjnNCoyjzLabpE1Hydm"; 
const encoder = new TextEncoder();
const decoder = new TextDecoder();

const getKey = async () => {
    const keyData = encoder.encode(SECRET_KEY);
    return await crypto.subtle.importKey("raw", keyData, { name: "AES-GCM" }, false, ["encrypt", "decrypt"]);
};

export const encryptId = async (id: number): Promise<string> => {
    try {
        const key = await getKey();
        const iv = crypto.getRandomValues(new Uint8Array(12)); 
        const encodedData = encoder.encode(id.toString());
        const encryptedData = await crypto.subtle.encrypt({ name: "AES-GCM", iv }, key, encodedData);

        const encryptedArray = new Uint8Array(encryptedData);
        const combinedArray = new Uint8Array(iv.length + encryptedArray.length);
        combinedArray.set(iv);
        combinedArray.set(encryptedArray, iv.length);

        return btoa(String.fromCharCode(...Array.from(combinedArray)))
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");
    } catch (error) {
        console.error("Erro ao criptografar:", error);
        return "";
    }
};


export const decryptId = async (encryptedId: string): Promise<number | null> => {
    try {
        const key = await getKey();

        const normalizedBase64 = encryptedId.replace(/-/g, "+").replace(/_/g, "/");

        const encryptedArray = Uint8Array.from(atob(normalizedBase64), c => c.charCodeAt(0));
        const iv = encryptedArray.slice(0, 12);
        const encryptedData = encryptedArray.slice(12);

        const decryptedData = await crypto.subtle.decrypt({ name: "AES-GCM", iv }, key, encryptedData);
        return parseInt(decoder.decode(decryptedData), 10);
    } catch (error) {
        console.error("Erro ao descriptografar:", error);
        return null;
    }
};

